import { Component, OnDestroy, OnInit } from '@angular/core';
import { AcaoGovernoService, Anexo5Ldo, Anexo6Ldo, Demo1Ldo, Demo2Ldo, Demo3Ldo, Demo4Ldo, Demo5Ldo, LdoService, MetaGovernoService } from 'administrativo-lib';
import { FonteFinanciamentoService } from 'contabil-lib';
import { ExecutoraService, Exercicio, FuncaoService, GlobalService, LoginPublico, OrgaoService } from 'eddydata-lib';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-transparencia-ldo',
  templateUrl: './transparencia-ldo.component.html'
})
export class TransparenciaLDOComponent implements OnInit, OnDestroy {

  public login: LoginPublico = new LoginPublico();
  public ano: number;
  public listaExercicios: Array<Exercicio>;
  public anexoSelect: string;
  public listaBalancetes: Array<any>;
  protected unsubscribe: Subject<void> = new Subject();
  private orgaos: number[] = [];

  constructor(
    protected fonteService: FonteFinanciamentoService,
    protected metaService: MetaGovernoService,
    protected acaoService: AcaoGovernoService,
    protected executoraService: ExecutoraService,
    protected orgaoService: OrgaoService,
    protected ldoService: LdoService,
    protected funcaoService: FuncaoService) {
    this.login = GlobalService.obterSessaoLogin();
    this.ano = this.login.exercicio.ano;
    this.orgaos.push(this.login.orgao.id);
  }

  ngOnInit() {
    this.listaExercicios = new Array();
    this.listaExercicios.push({ id: this.login.ppa.ppaperiodo.ano1, ano: this.login.ppa.ppaperiodo.ano1 });
    this.listaExercicios.push({ id: this.login.ppa.ppaperiodo.ano2, ano: this.login.ppa.ppaperiodo.ano2 });
    this.listaExercicios.push({ id: this.login.ppa.ppaperiodo.ano3, ano: this.login.ppa.ppaperiodo.ano3 });
    this.listaExercicios.push({ id: this.login.ppa.ppaperiodo.ano4, ano: this.login.ppa.ppaperiodo.ano4 });
    this.listaBalancetes = [
      { id: 'anexo5', nome: 'ANEXO V - DESCRIÇÃO DOS PROGRAMAS GOVERNAMENTAIS' },
      { id: 'anexo6', nome: 'ANEXO VI - UNIDADES EXECUTORAS E AÇÕES' },
      { id: 'demo1', nome: 'DEMONSTRATIVO I - METAS ANUAIS' },
      { id: 'demo2', nome: 'DEMONSTRATIVO II - AVALIAÇÃO DO CUMPRIMENTO DAS METAS FISCAIS DO EXERCÍCIO ANTERIOR' },
      { id: 'demo3', nome: 'DEMONSTRATIVO III - METAS FISCAIS COMPARADAS COM AS FIXADAS NOS TRÊS EXERCÍCIOS ANTERIORES' },
      { id: 'demo4', nome: 'DEMONSTRATIVO IV - EVOLUÇÃO DO PATRIMÔNIO LÍQUIDO' },
      { id: 'demo5', nome: 'DEMONSTRATIVO V - EVOLUÇÃO DO PATRIMÔNIO LÍQUIDO' },
    ];
  }

  imprimir() {
    if (this.anexoSelect === 'anexo5') {
      const anexo = new Anexo5Ldo(this.ano, this.metaService);
      anexo.montarRelatorio(this.orgaos);
    } else if (this.anexoSelect === 'anexo6') {
      const anexo = new Anexo6Ldo(this.ano, this.acaoService);
      anexo.montarRelatorio(this.orgaos);
    } else if (this.anexoSelect === 'demo1') {
      const demo = new Demo1Ldo(this.ano, this.ldoService);
      demo.montarRelatorio();
    } else if (this.anexoSelect === 'demo2') {
      const demo = new Demo2Ldo(this.ano, this.ldoService);
      demo.montarRelatorio();
    } else if (this.anexoSelect === 'demo3') {
      const demo = new Demo3Ldo(this.ano, this.ldoService);
      demo.montarRelatorio();
    } else if (this.anexoSelect === 'demo4') {
      const demo = new Demo4Ldo(this.ano, this.ldoService);
      demo.montarRelatorio();
    } else if (this.anexoSelect === 'demo5') {
      const demo = new Demo5Ldo(this.ano, this.ldoService);
      demo.montarRelatorio();
    } else {
      toastr.warning('Selecione o anexo a ser impresso');
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  /**
   * Método para verificação de objetos, usados em combos `<select>`
   */
  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 && c1.id && c2.id ? c1.id === c2.id : c1 === c2;
  }

}
